import { useCallback } from 'react';

import { useQuery } from '@apollo/client/react';
import { pickDefaultTemplate } from '@realadvisor/common-types';

import {
  Doc_Template_Type_Enum_Enum,
  type Doc_Templates,
  type Doc_Templates_Teams,
  type Doc_Templates_Tenants,
} from '@graphql/__generated__/graphql';
import { GET_DOC_TEMPLATES_FOR_DEFAULT } from '@modules/_shared/common/queries';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';

export type ApolloDocTemplate = Pick<
  Doc_Templates,
  'id' | 'name' | 'active'
> & {
  type?: Doc_Template_Type_Enum_Enum;
  doc_templates_tenants: Pick<
    Doc_Templates_Tenants,
    'tenant_id' | 'is_default'
  >[];
  doc_templates_teams?: Pick<Doc_Templates_Teams, 'team_id' | 'is_default'>[];
};

export const useGetDefaultApolloTemplate = () => {
  const { me } = useAppData();
  const tenantId = me?.tenant_id;
  const teamId = me?.default_team?.id;

  const getDefaultTemplate = useCallback(
    (
      templates: ApolloDocTemplate[] | null | undefined,
      type?: Doc_Template_Type_Enum_Enum,
    ) => pickDefaultTemplate(templates, { tenantId, teamId, type }),
    [tenantId, teamId],
  );

  return { getDefaultTemplate };
};

export const useDefaultLotBrochureTemplate = (skip: boolean) => {
  const { getDefaultTemplate } = useGetDefaultApolloTemplate();
  const { data, loading, error } = useQuery(GET_DOC_TEMPLATES_FOR_DEFAULT, {
    variables: { types: [Doc_Template_Type_Enum_Enum.LotBrochure] },
    skip,
  });

  return {
    defaultLotBrochureTemplateId:
      getDefaultTemplate(
        data?.doc_templates,
        Doc_Template_Type_Enum_Enum.LotBrochure,
      )?.id ?? null,
    hasLoadedDefaultLotBrochureTemplates: data != null,
    loading,
    error,
  };
};
